import React, {Component} from "react"
import {Grid} from "react-bootstrap"

import Button from "@irati/ui/src/Button"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Link from "@irati/ui/src/Link"
import {Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {FormattedMessage, InjectIntl, injectIntl, LangLoader} from "@irati/utils/lang"
import {PLATFORM} from "@irati-web/app/src/routeConfig"
import Spacing from "@irati/ui/src/Spacing"

import HorizontalBanner, {HorizontalBannerPositions} from "../HorizontalBanner"
import {FlexRow, CloseIconWrapper} from "./styled"

const COOKIE_NOTIFICATION_HIDE = "cookieNotificationHide"

interface Props extends InjectIntl {}

interface State {
  showCookieNotification: boolean
}

class CookieNotification extends Component<Props, State> {
  state: State = {
    showCookieNotification: true
  }

  onHideCookieNotification = () => {
    this.setState({showCookieNotification: false})
    localStorage.setItem(COOKIE_NOTIFICATION_HIDE, "true")
  }

  render() {
    const {formatMessage} = this.props

    if (!this.state.showCookieNotification || localStorage.getItem(COOKIE_NOTIFICATION_HIDE)) {
      return null
    }
    const link = (
      <Link href={formatMessage({id: "platform.cookieNotification.link.href"})} target="_blank">
        <FormattedMessage id="platform.cookieNotification.link.text" />
      </Link>
    )

    return (
      <LangLoader bucket={PLATFORM}>
        <HorizontalBanner position={HorizontalBannerPositions.BOTTOM}>
          <Grid>
            <FlexRow>
              <Flex>
                <CloseIconWrapper onClick={this.onHideCookieNotification}>
                  <Spacing marginRight={1}>
                    <Icon icon={IconTypes.close} color="white" />
                  </Spacing>
                </CloseIconWrapper>
                <Body small color="white" marginBottom={0}>
                  <FormattedMessage id="platform.cookieNotification.body" values={{link}} />
                </Body>
              </Flex>
              <Button inverted id="dontShowThisAgainId" onClick={this.onHideCookieNotification}>
                <FormattedMessage id="platform.cookieNotification.dismiss" />
              </Button>
            </FlexRow>
          </Grid>
        </HorizontalBanner>
      </LangLoader>
    )
  }
}

export default injectIntl(CookieNotification)
